import './style.scss';

const toggleAccordion = () => {
	const btns = document.getElementsByClassName('accordion-btn');

	if (!btns) return;

	[...btns].forEach((elem) => {
		elem.addEventListener('click', function() {
			const container = this.parentNode;

			if (!container) return;

			container.classList.toggle('accordion-is-close');
		})
	})
}
toggleAccordion();

const toggleInitialOpen = () => {

	const container = document.getElementsByClassName('accordion-container');

	if (!container || container.length === 0) return;

	const urlHash = location.hash;

	if (!urlHash) return;

	const hash = urlHash.replace("#", "");

	const targetElem = document.getElementById(hash);

	if(targetElem) {
		targetElem.classList.remove('accordion-is-close');
	}
}
toggleInitialOpen();